/** @jsxImportSource theme-ui */
import React from 'react';
import { Divider } from 'semantic-ui-react';

import { sxtheme } from 'utils/cssHelpers';
import { formatDateUntilToday } from 'utils/dateTimeHelpers';
import { formatNumber } from 'utils/stringFormattingHelpers';

import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';

import { SparkTooltipLoading } from './DaSparkTooltipLoading';

type SparkTooltipProps = {
  isGlobal?: boolean;
  isLoading?: boolean;
  sumCases: number;
  timeframeStartDate: Date;
  aggregationDaysStr: string;
};

export const SparkTooltip: React.FC<SparkTooltipProps> = ({
  isGlobal = false,
  isLoading = false,
  sumCases,
  timeframeStartDate,
  aggregationDaysStr,
}) => {
  const reportedLabel = isGlobal ? 'reported globally from' : 'reported from';

  return isLoading ? (
    <SparkTooltipLoading />
  ) : !sumCases ? (
    <>
      <Typography variant="subtitle2" color="stone10">
        Insufficient case data
      </Typography>
      <Typography variant="caption" color="stone10">
        From {formatDateUntilToday(timeframeStartDate)}
      </Typography>
    </>
  ) : (
    <>
      <Typography variant="subtitle2" color="stone10">
        {formatNumber(sumCases, 'case')}
      </Typography>
      <Typography variant="caption" color="stone10">
        {reportedLabel}
      </Typography>
      <Typography variant="caption" color="stone10">
        {formatDateUntilToday(timeframeStartDate)}
      </Typography>
      <Divider className="spark-tooltip" />
      <FlexGroup
        prefix={
          <div
            sx={{
              bg: sxtheme(t => t.colors.sea50),
              borderRadius: '2px',
              width: '10px',
              height: '10px',
            }}
          />
        }
      >
        <Typography variant="caption" color="stone10">
          Each bar = {aggregationDaysStr}
        </Typography>
      </FlexGroup>
    </>
  );
};
